/**
 * 处理轮播图每帧四图数据
 * @param {Array} data 数组数据
 */
export const handleSlideData = data => {
    const urlArr = [];
    let eachFrame = [];

    for (let i = 0, len = data.length; i < len; i++) {
        if ((i + 1) % 4 !== 0) {
            eachFrame.push(data[i]);
        } else {
            eachFrame.push(data[i]);
            urlArr.push(eachFrame);
            eachFrame = [];
        }
    }

    return urlArr;
};
